import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import httpInterceptor from "../../common/APIConfig";

/**
 * Async thunk to update VM cron schedule
 *
 * @param {Object} payload - request payload
 * Required fields:
 * account_id: string
 * resource_tag: string
 * resource_id: string
 * cron_expression: string
 * action: "start" | "stop"
 */
export const updateAWSDBSchedule = createAsyncThunk(
  "AWSDBSchedule/update",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await httpInterceptor.post(
        "/resources/aws/cron",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({ message: "Failed to update VM schedule" });
      }
    }
  }
);

const updateAWSDBScheduleSlice = createSlice({
  name: "updateAWSDBSchedule",
  initialState: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  reducers: {
    resetUpdateAWSDBSchedule: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateAWSDBSchedule.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(updateAWSDBSchedule.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(updateAWSDBSchedule.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload || { message: "Something went wrong" };
      });
  },
});

export const { resetUpdateAWSDBSchedule } = updateAWSDBScheduleSlice.actions;
export default updateAWSDBScheduleSlice.reducer;
